import { useState } from 'react'

type ReturnType = {
  values: Set<number>
  expand: (ids: number[], reset?: boolean) => Set<number>
  reset: () => void
  toggle: (id: number) => Set<number>
}

const useUncollpasedNodes = (initial: Set<number>): ReturnType => {
  const [values, setValues] = useState(initial)

  const expand = (ids: number[], reset?: boolean): Set<number> => {
    const previousUncollapsedNodes = reset ? [] : values
    const nextValues = new Set([...previousUncollapsedNodes, ...ids])

    setValues(nextValues)

    return nextValues
  }

  const toggle = (id: number): Set<number> => {
    const nextUncollapsedNodes = values.has(id)
      ? [...values].filter((x) => x !== id)
      : [...values, id]
    const nextValues = new Set(nextUncollapsedNodes)

    setValues(nextValues)

    return nextValues
  }

  const reset = (): void => {
    setValues(new Set([]))
  }

  return { values, expand, toggle, reset }
}

export default useUncollpasedNodes
